import './DonationConfirm.css';
import { useEffect } from 'react';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export default function SubscriptionSuccess() {
    const location = useLocation()
    useEffect(()=>{
      ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Subscription Success Page' });
    }, []);
    return <div className="donation-confirm-container" style={{display:'flex',justifyContent:'center', flexDirection: 'column',width: "50%",marginRight: "auto",marginLeft: "auto"}}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Subscription Success</title>
      </Helmet>
      <div style={{ margin: '5rem auto' }}>
        <p>Thank you for joining our global community!</p>
      </div>
    </div>
}